import { Injectable } from '@angular/core';

function _window(): any {
   // return the global native browser window object
   return window;
}
/**
 * This service is a window service
 *
 * @example
 * WindowRefService.nativeWindow;
 *
 */
@Injectable()
export class WindowRefService {
    get nativeWindow(): any {
        return _window();
    }
}
